import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

gsap.defaults({
    ease: "ease",
    duration: 1,
});

gsap.config({
    nullTargetWarn: true,
    autoSleep: 60,
    force3D: false,
});

import { runDefault, runLayoutDefault, runComponentDefault, runModuleDefault } from "./utils/runner-functions";

import { initVariables } from "./utils/variables";
import { initLinkPrefetch } from "./utils/link-prefetch";
import { initScroller } from "./base/scroll";

function init() {
    initGlobalScripts();
    initLayoutScripts();
    initComponentScripts();
    initModuleScripts();
}

function initGlobalScripts() {
    initVariables();
    initScroller();
    initLinkPrefetch();
    runDefault("grid");
    runDefault("ajax");
}

function initLayoutScripts() {
    runLayoutDefault("footer");
    runLayoutDefault("header");
    runLayoutDefault("quick-exit");
}

function initComponentScripts() {
    runComponentDefault("c-select", ".c-select, .lang-select");
    runComponentDefault("headings");
    runComponentDefault("fade-in");
    runComponentDefault("accordion");
    runComponentDefault("range-slider", ".range-slider");
    runComponentDefault("spend-calculator", ".spend-calculator");
    runComponentDefault("video-modal", "[data-video-src], [data-iframe-src]");
}

function initModuleScripts() {
    runModuleDefault("home-hero", ".home-hero");
    runModuleDefault("quiz", ".quiz");
    runModuleDefault("slider", ".slider");
    runModuleDefault("downloads", ".downloads");
    runModuleDefault("locations", ".locations");
}

function safeInit() {
    requestAnimationFrame(() => setTimeout(init, 1));
}

if (!(document.readyState === "loading")) safeInit();
else document.addEventListener("DOMContentLoaded", safeInit);
